<template>
  <div>
    <v-app-bar
      flat
      color="transparent"
    >
      <v-toolbar-title>
        Matches SEO
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search name, email or phone number"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt=""
        >
      </v-btn> -->
    </v-app-bar>
    <div
      class="pa-4"
      id="best-promo-list"
    >
      <div class="d-flex flex-row justify-space-between px-4">
        <div class="article-filters d-flex flex-row">

          <v-text-field
            dense
            label="Match ID"
            placeholder="search match ID"
            v-model="searchString"
            outlined
          >

          </v-text-field>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="ml-3"
                color="primary"
                @click="search"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>Search Match ID</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="ml-3"
                color="primary"
                @click="searchString = ''; search()"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Reset Filter</span>
          </v-tooltip>
        </div>
        <v-chip>Total: {{ listMeta.total | formatNumber }}</v-chip>
      </div>
      <v-simple-table>
        <thead>
          <tr>
            <th>Match ID</th>
            <th>Title</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(list, i) in recordList"
            :key="i"
            class="hoverable"
          >
            <td @click="editRecord(list.id)">
              {{  list.match_id }}
            </td>
            <td @click="editRecord(list.id)">
              {{  list.social_summary_title }}
            </td>
            <td class="text-center">
              <v-menu
                transition="slide-x-transition"
                bottom
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="hoverable"
                    v-bind="attrs"
                    v-on="on"
                  >mdi-dots-vertical</v-icon>
                </template>
                <v-list>
                  <v-list-item class="hoverable">
                    <v-list-item-title @click="editRecord(list.id)">
                      <v-icon>mdi-file-edit</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item class="hoverable">
                    <v-list-item-title @click="triggerDelete(list.id, i)">
                      <v-icon>mdi-delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr v-if="loading">
            <td
              class="pl-0"
              v-for="n in 3"
              :key="n"
            >
              <v-skeleton-loader type="list-item" />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div
        v-if="listMeta.total"
        class="py-5 d-flex justify-center"
      >
        <small class="grey--text lighten-4">
          {{ listMeta.from }}-{{ listMeta.to }} of
          {{ listMeta.total | formatNumber }}
        </small>
      </div>
    </div>
    <div
      class="text-center mt-2 mb-8"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
    <v-btn
      color="success"
      fab
      large
      dark
      bottom
      right
      fixed
      class="mb-4"
      :to="{name: 'bethub-pages.create'}"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'BetHubPagesMetaPage',
  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Fetching Data',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      searchString: ''
    }
  },

  computed: {
    ...mapState({
      recordList: state => state.betHubPages.list,
      listMeta: state => state.betHubPages.listMeta,
      requestStatus: state => state.betHubPages.requestStatus,
      requestMsg: state => state.betHubPages.requestMsg
    })
  },

  methods: {
    ...mapActions({
      getList: 'betHubPages/getList',
      updateRecord: 'betHubPages/update',
      deleteRecord: 'betHubPages/delete'
    }),

    editRecord (id) {
      this.$router.push({ name: 'bethub-pages.edit', params: { id } })
    },

    async triggerDelete (id, index) {
      this.updating = true
      this.loading_message = 'Deleting'
      await this.deleteRecord(id)
        .then(response => {
          this.recordList.splice(index, 1)
          this.showSnackbar(this.requestMsg)
          this.updating = false
        })
        .catch(err => {
          console.log(err)
          this.showSnackbar(this.requestMsg)
        })
    },

    async fetcRecordList (page = 1) {
      let params = { page }
      params.search = this.searchString
      params.sort = '-created_at'
      this.updating = true
      this.loading_message = 'Fetching Data'
      await this.getList(params)
      this.updating = false
    },

    showSnackbar (message) {
      this.snackbar.color = this.requestStatus
      this.snackbar.message = message
      this.snackbar.show = true
    },

    pageChanged (page) {
      this.fetcRecordList(page)
    },

    search: debounce(function () {
      this.fetcRecordList()
    }, 600)
  },

  created () {
    this.fetcRecordList()
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  }
}
</script>

<style scoped>
.hoverable:hover {
  cursor: pointer;
}
</style>
